import { FC, memo } from 'react';

import './LoadingPlaceholder.scss';

interface LoadingPlaceholderProps {
  width: string;
  height: string;
}

const LoadingPlaceholderComponent: FC<LoadingPlaceholderProps> = ({ width, height }) => {
  return <div className="nostra__loadingPlaceholder" style={{ width: width, height: height }} />;
};
export const LoadingPlaceholder = memo(LoadingPlaceholderComponent);
